module.exports = "/_next/static/images/sellers_3_en-b3ee98eaf7f088a1f48bbaa191a2d8e9.png";